import { Autocomplete, Box, Button, FormControl, IconButton, InputLabel, LinearProgress, Link, MenuItem, Modal, Select, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material'
import Grid from "@mui/material/Grid2";
import { Location } from "src/stateManagement/redux/slices/location/interfaces";
import CloseIcon from '@mui/icons-material/Close';
import './styles.scss'
import { useSelector, useDispatch } from "src/stateManagement/redux";
import { useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SearchIcon from '@mui/icons-material/Search';
import { assignedActivitiesToUser } from 'src/shared/util/updateDataServer';
import { getLocations } from 'src/stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import Swal from "sweetalert2";
import { getDatesBetween } from 'src/shared/util/datesFunctions';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { getPlanningActivitiesForDates } from 'src/shared/util/requestDataServer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import moment from 'moment';
import { CustomColors } from 'src/styles/colors';
import { tableStyles } from 'src/shared/util/tableStyles';

interface ActivitiesByAnalyser {
    userId: string;
    fullName: string;
    assignedWithoutProduction: number;
    assignedWithProduction: number;
}

interface PendingActivitiesByDate {
    date: string;
    activities: number;
}

interface SummaryActivities {
    totalActivities: number;
    assignedActivities: number;
    echometerTotalActivities: number;
    echometerAssignedActivities: number;
    leutertTotalActivities: number;
    leutertAssignedActivities: number;
    methods: string[];
    typeOfActivities: string[];
    locationWithProduction: number;
    locationWithoutProduction: number;
}

interface InternalFilters {
    method: string[];
    typeOfActivities: string[];
    withoutProductionTaken: number;
    withProductionTaken: number;
}

export interface ActivitiesByDatesToAssigned {
    date: string;
    assignedActivitiesIds: string[];
    comment?: string;
}

export const AssignedModule = ({ datesToAssigned, data, setloading, goBack }: { datesToAssigned: any, data: Location[], setloading: any, goBack: any }) => {

    const { users } = useSelector((state) => state.gerenciaTecnica);

    const [analyzerUsers, setanalyzerUsers] = useState<ActivitiesByAnalyser[]>([])

    const [pendingAnalystByDate, setPendingAnalystByDate] = useState<PendingActivitiesByDate[]>([])

    const [summaryActivities, setSummaryActivities] = useState<SummaryActivities>({
        totalActivities: 0,
        assignedActivities: 0,
        echometerTotalActivities: 0,
        echometerAssignedActivities: 0,
        leutertTotalActivities: 0,
        leutertAssignedActivities: 0,
        methods: [],
        typeOfActivities: [],
        locationWithProduction: 0,
        locationWithoutProduction: 0
    })

    const [activeTab, setActiveTab] = useState(0)

    const [activeTabDateEngineers, setActiveTabDateEngineers] = useState(0)

    const [activitiesTaken, setActivitiesTaken] = useState<Location[]>([])

    const [selectedRows, setSelectedRows] = useState<string[]>([]);

    const [unSelectedRows, setUnSelectedRows] = useState<string[]>([]);

    const [showEngineerDetail, setShowEngineerDetail] = useState(false)

    const [showAssignedTasks, setShowAssignedTasks] = useState(true)

    const [activitiesAssignedWithDate, setActivitiesAssignedWithDate] = useState(0)

    const [activeUser, setActiveUser] = useState({ id: '', fullName: '' })

    const [filteredActivitiesWithoutProduction, setFilteredActivitiesWithoutProduction] = useState<Location[]>([])

    const [filteredActivitiesWithProduction, setFilteredActivitiesWithProduction] = useState<Location[]>([])

    const [activitiesDistributedByDay, setActivitiesDistributedByDay] = useState<ActivitiesByDatesToAssigned[]>([])

    const [activitiesTakenFromUnselected, setActivitiesTakenFromUnselected] = useState<boolean>(false)

    const [editingActivitiesPreTraken, setEditingActivitiesPreTraken] = useState(false)

    const [datesFromPreTakenActivities, setDatesFromPreTakenActivities] = useState<string[]>([])

    const [lastRequestforPlaningActivities, setlastRequestforPlaningActivities] = useState<any>(undefined)

    const [filters, setFilters] = useState<InternalFilters>({
        method: [],
        typeOfActivities: [],
        withoutProductionTaken: 0,
        withProductionTaken: 0
    })

    const columns: GridColDef[] = [
        { field: "userId", headerName: "idUsuario", hideable: true, width: 1 },
        { field: "fullName", headerName: "Ingeniero", flex: 1 },
        { field: "assignedWithoutProduction", headerName: "Sin Aporte Asignadas", flex: 1 },
        { field: "assignedWithProduction", headerName: "Aportando Asignadas", flex: 1 },
        {
            field: "action",
            headerName: "",
            sortable: false,
            filterable: false,
            flex: 0.8,
            renderCell: (params) => {
                return (
                    <Grid sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center' }}>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => { handleOnActiveTab(true, 0, params.row.userId, params.row.fullName) }}
                        >
                            <AddCircleOutlineIcon fontSize="medium" />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => { handleOnActiveTab(true, 1, params.row.userId, params.row.fullName) }}
                        >
                            <SearchIcon fontSize="medium" />
                        </IconButton>
                        {(params.row?.assignedWithProduction > 0 || params.row?.assignedWithoutProduction > 0) && (
                            <Tooltip
                                title="Quitar Todas las Actividades del ingeniero para la fecha seleccionada"
                                placement="top"
                                arrow>
                                <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleUnAssignActivities(params.row.userId)}
                                >
                                    <PlaylistRemoveIcon />
                                </IconButton>
                            </Tooltip>
                        )}

                    </Grid>
                );
            },
        },
    ];

    const columnsFordate: GridColDef[] = [
        { field: "date", headerName: "Fecha", flex: 1 },
        { field: "activities", headerName: "Actividades Pendientes", flex: 1 },
    ];

    const columnsTakenActivities: GridColDef[] = [
        { field: "activityId", headerName: "activityId", flex: 0.6 },
        { field: "locationName", headerName: "Locación", flex: 0.6 },
        { field: "method", headerName: "Metodo", flex: 0.5 },
        // { field: "executedDate", headerName: "Ultima visita", flex: 0.7 },
        // { field: "lastAssignedDate", headerName: "Fecha asignada", flex: 0.7 },
        {
            field: "executedDate", headerName: "Ultima visita", flex: 0.7, renderCell: (params) => {
                const fieldDate = params.row.executedDate
                    ? moment(params.row.executedDate).local().format('DD-MMM-YY')
                    : 'No asignada';

                const assignedDate = params.row.lastAssignedDate
                    ? moment(params.row.lastAssignedDate).local().format('DD-MMM-YY')
                    : 'No asignada';

                const isAssigned = fieldDate !== assignedDate;

                return (<Typography variant="body2" sx={{
                    height: '100%',
                    display: 'flex',
                    textWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    color: !isAssigned ? 'black' : 'red',
                }}>
                    {fieldDate}
                </Typography>)
            }
        },
        {
            field: "lastAssignedDate", headerName: "Fecha asignada", flex: 0.7, renderCell: (params) => {

                const fieldDate = params.row.executedDate
                    ? moment(params.row.executedDate).local().format('DD-MMM-YY')
                    : 'No asignada';

                const assignedDate = params.row.lastAssignedDate
                    ? moment(params.row.lastAssignedDate).local().format('DD-MMM-YY')
                    : 'No asignada';


                const isAssigned = fieldDate !== assignedDate;

                return (<Typography variant="body2" sx={{
                    height: '100%',
                    display: 'flex',
                    textWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    color: !isAssigned ? 'black' : 'red',
                }}>
                    {assignedDate}
                </Typography>)
            }
        },
        { field: "zone", headerName: "Sector", flex: 0.5 },
        { field: "opeStatusInicio", headerName: "Ope Status Ini", flex: 1 },
        { field: "opeStatusFin", headerName: "Ope Status Fin", flex: 1 },
        // { field: "pot", headerName: "Pot", flex: 0.4 },
        { field: "activity", headerName: "Actividad", flex: 1 },
        { field: "pumpCondition", headerName: "Condicion de Fondo", flex: 1 },
        { field: "expectedAnalysisDate", headerName: "Fecha Analisis Esperada", flex: 1 },
    ];


    useEffect(() => {

        if (!users || users.length === 0) {
            return;
        }

        const filteredUsers = users.filter(user => user?.role?.includes('Aplicaciones Tierra'));

        const usersToTable: ActivitiesByAnalyser[] = []

        for (const user of filteredUsers) {


            // const assignedActivitiesToUser = data.filter(x => x.assignedAnalyzerUserId === user.id);

            // const assignedWithoutProduction = assignedActivitiesToUser.filter(x => ["Sin Aporte", "Sin Produción"].includes(x.opeStatusFin)).length;

            // const assignedWithProduction = assignedActivitiesToUser.filter(x => ["Operando", "Aportando", "Restaurado", "Recolocado", "Observación"].includes(x.opeStatusFin)).length;

            const filteredActivitiesWithoutProduction = []

            const filteredActivitiesWithProduction = []

            for (const location of data) {

                if (!location.assignedAnalyzerUserId || location.assignedAnalyzerUserId !== user.id) {
                    continue;
                }

                const opeStatusInicialInNotProduction = ["IT", "Observación", "Sin Aporte"].includes(location.opeStatusInicio);

                const opeStatusFinalInNotProduction = ["IT", "Observación", "Restaurado", "Sin Aporte", "Sin Produción", "Sin Producción"].includes(location.opeStatusFin);

                if (opeStatusInicialInNotProduction || opeStatusFinalInNotProduction) {
                    filteredActivitiesWithoutProduction.push(location);
                } else {
                    filteredActivitiesWithProduction.push(location);
                }
            }

            const activitiesByAnalyser: ActivitiesByAnalyser = {
                userId: user.id,
                fullName: user.name,
                assignedWithoutProduction: filteredActivitiesWithoutProduction?.length || 0,
                assignedWithProduction: filteredActivitiesWithProduction?.length || 0,
            };

            usersToTable.push(activitiesByAnalyser);
        }

        setanalyzerUsers(usersToTable);

        const uniquesDatesOfActivities = Array.from(new Set(data.map(x => {

            let date: any = x.executedDate;

            if (typeof date === "string") {
                date = new Date(date).toISOString().split('T')[0];
            }

            return date;
        })));

        const activitiesPendingbyDate: any[] = []

        for (const date of uniquesDatesOfActivities) {

            const activitiesPending = data.filter(x => {
                let executedDate: any = x.executedDate;

                if (typeof executedDate === "string") {
                    executedDate = new Date(executedDate).toISOString().split('T')[0];
                }

                return executedDate === date;
            });

            activitiesPendingbyDate.push({
                date,
                activities: activitiesPending?.length || 0,
                activitiesIds: activitiesPending?.map(x => x.activityId).join(',')
            })
        }

        setPendingAnalystByDate(activitiesPendingbyDate);

    }, [users, data])

    useEffect(() => {

        if (!data || data.length === 0) {
            return;
        }

        const totalActivities = data.length;
        const assignedActivities = data.filter(x => x.assignedAnalyzerUserId).length;

        const echometerTotalActivities = data.filter(x => x.type === 'Echometer BM' || x.type === 'Echometer BCP').length;
        const echometerAssignedActivities = data.filter(x => (x.type === 'Echometer BM' || x.type === 'EchometerBCP') && x.assignedAnalyzerUserId).length;

        const leutertTotalActivities = data.filter(x => x.type === "Leuter Digital").length;
        const leutertAssignedActivities = data.filter(x => x.type === "Leuter Digital" && x.assignedAnalyzerUserId).length;

        const methods = Array.from(new Set(data.map(x => x.method)));

        const typeOfActivities = Array.from(new Set(data.map(x => x.type)));

        const locationWithProduction: any[] = []
        const locationWithoutProduction: any[] = []

        const filteredActivitiesWithoutProduction = []

        const filteredActivitiesWithProduction = []

        for (const location of data) {

            if (location.assignedAnalyzerUserId) {
                continue;
            }

            const opeStatusInicialInNotProduction = ["IT", "Observación", "Sin Aporte"].includes(location.opeStatusInicio);

            const opeStatusFinalInNotProduction = ["IT", "Observación", "Restaurado", "Sin Aporte", "Sin Produción", "Sin Producción"].includes(location.opeStatusFin);

            if (opeStatusInicialInNotProduction || opeStatusFinalInNotProduction) {
                filteredActivitiesWithoutProduction.push(location);
            } else {
                filteredActivitiesWithProduction.push(location);
            }
        }

        setFilteredActivitiesWithoutProduction(filteredActivitiesWithoutProduction);

        setFilteredActivitiesWithProduction(filteredActivitiesWithProduction);

        setSummaryActivities({
            totalActivities,
            assignedActivities,
            echometerTotalActivities,
            echometerAssignedActivities,
            leutertTotalActivities,
            leutertAssignedActivities,
            methods,
            typeOfActivities,
            locationWithProduction: filteredActivitiesWithProduction.length,
            locationWithoutProduction: filteredActivitiesWithoutProduction.length
        })

    }, [data])

    useEffect(() => {

        let allLocations = data || [];

        if (filters.method.length > 0) {
            allLocations = allLocations.filter(x => filters.method.includes(x.method));
        }

        if (filters.typeOfActivities.length > 0) {
            allLocations = allLocations.filter(x => filters.typeOfActivities.includes(x.type));
        }

        const filteredActivitiesWithoutProduction = []

        const filteredActivitiesWithProduction = []

        for (const location of allLocations) {

            if (location.assignedAnalyzerUserId) {
                continue;
            }

            const opeStatusInicialInNotProduction = ["IT", "Observación", "Sin Aporte"].includes(location.opeStatusInicio) && !location.assignedAnalyzerUserId;

            const opeStatusFinalInNotProduction = ["IT", "Observación", "Restaurado", "Sin Aporte", "Sin Produción", "Sin Producción"].includes(location.opeStatusFin) && !location.assignedAnalyzerUserId;

            if (opeStatusInicialInNotProduction || opeStatusFinalInNotProduction) {
                filteredActivitiesWithoutProduction.push(location);
            } else {
                filteredActivitiesWithProduction.push(location);
            }
        }

        setFilteredActivitiesWithoutProduction(filteredActivitiesWithoutProduction);

        setFilteredActivitiesWithProduction(filteredActivitiesWithProduction);

        // const filteredActivitiesWithoutProduction = allLocations.filter(x => ["Sin Aporte", "Sin Produción","Sin Producción","IT"].includes(x.opeStatusFin) && !x.assignedAnalyzerUserId);


        // const filteredActivitiesWithProduction = allLocations.filter(x => ["Operando", "Aportando", "Restaurado", "Recolocado", "Observación"].includes(x.opeStatusFin) && !x.assignedAnalyzerUserId);


    }, [filters])

    useEffect(() => {

        // if (!activitiesTakenFromUnselected) {
        //     setSelectedRows(activitiesTaken.map(row => row.activityId));
        // } else {
        //     setActivitiesTakenFromUnselected(false);
        // }


        if (activeUser.id) {

            let datesBetween = getDatesBetween(datesToAssigned.startDate, datesToAssigned.endDate);

            if (editingActivitiesPreTraken && datesFromPreTakenActivities.length === 0) {
                datesBetween = Array.from(
                    new Set(
                        activitiesTaken
                            .map(x => x.expectedAnalysisDate)
                            .filter(Boolean)
                            .map(date => {
                                if (!date) return '';
                                return new Date(date).toISOString().split('T')[0];
                            })
                    )
                ).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

                setDatesFromPreTakenActivities(datesBetween);
            } else if (editingActivitiesPreTraken && datesFromPreTakenActivities.length > 0) {
                datesBetween = datesFromPreTakenActivities;
            }

            let activitiesAssignedWithDate = 0;

            let requestFromServer = false;

            if (!lastRequestforPlaningActivities) {
                requestFromServer = true;
            } else if (lastRequestforPlaningActivities?.startDate !== datesBetween[0] || lastRequestforPlaningActivities?.endDate !== datesBetween[datesBetween.length - 1]) {
                requestFromServer = true;
            }

            if (requestFromServer) {
                setloading(true);
                getPlanningActivitiesForDates(datesBetween[0], datesBetween[datesBetween.length - 1], "Plan Analisis Optimizacion").then((plannedActivitiesFromServer: any[]) => {
                    const activitiesByDates: ActivitiesByDatesToAssigned[] = datesBetween.map(date => {
                        const assignedActivitiesIds = activitiesTaken
                            .filter(activity => {

                                if (!activity.expectedAnalysisDate) return null;

                                const analisisExpectedDate = new Date(activity.expectedAnalysisDate).toISOString().split('T')[0];

                                return analisisExpectedDate === date
                            })
                            .map(activity => activity.activityId);
                        if (assignedActivitiesIds.length > 0) {
                            activitiesAssignedWithDate += assignedActivitiesIds.length;
                        }

                        let previousActivity = activitiesDistributedByDay.find(activity => activity.date === date);

                        if (!previousActivity) {
                            const existPlannedActivity = plannedActivitiesFromServer.find(activity => activity.assignedUser.id === activeUser.id && activity.planningEndDate === date);

                            if (existPlannedActivity) {

                                const previousComment = existPlannedActivity?.variables?.find((v: any) => v.name === 'comentario')?.value

                                previousActivity = {
                                    date,
                                    assignedActivitiesIds: [],
                                    comment: previousComment || ''
                                };

                            }
                        }

                        return { date, assignedActivitiesIds, comment: previousActivity?.comment || '' };
                    });
                    setActivitiesDistributedByDay(activitiesByDates);
                    setlastRequestforPlaningActivities({
                        startDate: datesBetween[0],
                        endDate: datesBetween[datesBetween.length - 1]
                    });
                }).finally(() => {
                    setloading(false);
                });
            } else {
                const activitiesByDates: ActivitiesByDatesToAssigned[] = datesBetween.map(date => {
                    const assignedActivitiesIds = activitiesTaken
                        .filter(activity => {

                            if (!activity.expectedAnalysisDate) return null;

                            const analisisExpectedDate = new Date(activity.expectedAnalysisDate).toISOString().split('T')[0];

                            return analisisExpectedDate === date
                        })
                        .map(activity => activity.activityId);
                    if (assignedActivitiesIds.length > 0) {
                        activitiesAssignedWithDate += assignedActivitiesIds.length;
                    }

                    let previousActivity = activitiesDistributedByDay.find(activity => activity.date === date);

                    return { date, assignedActivitiesIds, comment: previousActivity?.comment || '' };
                });
                setActivitiesDistributedByDay(activitiesByDates);
            }


            setActivitiesAssignedWithDate(activitiesAssignedWithDate);
        }

    }, [activitiesTaken]);


    const dispatch = useDispatch();

    const handleOnActiveTab = (value: boolean, tab: number, userId: string, fullName: string) => {
        if (value) {
            setActiveTab(tab);
            setShowEngineerDetail(true);
            if (tab === 1) {
                setShowAssignedTasks(false);
                const activitiesTaken = data.filter(x => x.assignedAnalyzerUserId === userId);
                setActivitiesTaken(activitiesTaken);
                setEditingActivitiesPreTraken(true);
            } else {
                setShowAssignedTasks(true);
            }
        } else {
            setActiveTab(0);
            setShowEngineerDetail(false);
        }

        setActiveUser({ id: userId, fullName: fullName });
    }

    const handleTakeActivities = () => {

        const takenWithoutProduction = filteredActivitiesWithoutProduction.slice(0, filters.withoutProductionTaken);
        const takenWithProduction = filteredActivitiesWithProduction.slice(0, filters.withProductionTaken);
        const takenActivities = [...takenWithoutProduction, ...takenWithProduction];
        setActivitiesTaken(takenActivities);
        setSelectedRows(takenActivities.map(row => row.activityId));

        setActiveTab(1);
    }

    const handleChangeSelect = (field: string, value: any) => {

        let newValue = value;

        if (['withoutProductionTaken', 'withProductionTaken'].includes(field)) {
            newValue = parseInt(value, 10) || 0; // Ensure it's a number
        }

        if (field === "withoutProductionTaken" && newValue > filteredActivitiesWithoutProduction.length) {
            newValue = filteredActivitiesWithoutProduction.length;

        }

        if (field === "withProductionTaken" && newValue > filteredActivitiesWithProduction.length) {
            newValue = filteredActivitiesWithProduction.length;
        }

        setFilters((prevFilters) => ({
            ...prevFilters,
            [field]: newValue
        }));
    }

    const handleCloseEngineerDetail = () => {
        setShowEngineerDetail(false);
        setActiveTab(0);
        setActiveUser({ id: '', fullName: '' });
        setSelectedRows([]);
        setActivitiesTaken([]);
        setActivitiesDistributedByDay([]);
        setEditingActivitiesPreTraken(false);
        setFilters({
            method: [],
            typeOfActivities: [],
            withoutProductionTaken: 0,
            withProductionTaken: 0
        });
    }

    const handleUnAssignActivities = (userid: string) => {
        const activitiesTaken = data.filter(x => x.assignedAnalyzerUserId === userid);
        const rowsToUnassigned = activitiesTaken.map(activity => activity.activityId);


        setloading(true);
        assignedActivitiesToUser(userid, [], rowsToUnassigned).then((data) => {
            Swal.fire({
                title: "Guardado!",
                icon: "success",
            });
            dispatch(getLocations(true));
        }).finally(() => {
            setloading(false);
        });
    }

    const handleAssignedActivities = () => {

        const activitiesSelected = activitiesDistributedByDay?.filter(activity => activity.assignedActivitiesIds.length > 0);

        if (activitiesSelected.length === 0) {
            Swal.fire({
                title: "Debe seleccionar al menos una actividad",
                icon: "warning",
            });
            return;
        }

        // if (activitiesAssignedWithDate !== selectedRows.length) {
        //     Swal.fire({
        //         title: `Debe asignar todas las actividades, ha asignado ${activitiesAssignedWithDate} de ${selectedRows.length}`,
        //         icon: "warning",
        //     });
        //     return;
        // }


        setloading(true);
        assignedActivitiesToUser(activeUser.id, activitiesSelected, unSelectedRows).then((data) => {
            Swal.fire({
                title: "Guardado!",
                icon: "success",
            });
            dispatch(getLocations(true));
        }
        ).catch((error) => {
            Swal.fire({
                title: "Error!",
                icon: "error",
            });
            console.log(error)
        }).finally(() => {
            setloading(false);
        });
    }

    const onSelectRows = (rows: string[]) => {

        setActivitiesTakenFromUnselected(true);

        const newUnselectedRows = selectedRows.filter(row => !rows.includes(row));

        const activityTaken = activitiesTaken.filter(activity => newUnselectedRows.includes(activity.activityId));

        const newActivitiesTaken = [...activitiesTaken];

        for (const activityUnselected of activityTaken) {

            const index = newActivitiesTaken.findIndex(activity => activity.activityId === activityUnselected.activityId);
            if (index !== -1) {
                newActivitiesTaken[index] = {
                    ...newActivitiesTaken[index],
                    expectedAnalysisDate: undefined
                };
            }

        }

        const previousUnselectedRows = unSelectedRows.filter(row => !rows.includes(row));

        const unselectedRows = Array.from(new Set([...newUnselectedRows, ...previousUnselectedRows]));

        setUnSelectedRows(unselectedRows);

        setActivitiesTaken(newActivitiesTaken);

        setSelectedRows(rows);
    }

    const handleDistributeActivities = () => {

        if (selectedRows.length === 0) {
            Swal.fire({
                title: "Debe seleccionar al menos una actividad",
                icon: "warning",
            });
            return;
        }
        setActiveTab(2);
    }

    const handleOnChangeAssignedActivities = (e: any, date: string, field: string) => {
        const value = e.target.value;

        const activityIndex = activitiesDistributedByDay.findIndex(activity => activity.date === date);

        if (activityIndex !== -1) {

            if (field === 'plan') {

                const activityDistributed = activitiesDistributedByDay[activityIndex];

                const selectedActivities = activitiesTaken.filter(activity => selectedRows.includes(activity.activityId));

                const activitiesTakenNotAssigned = selectedActivities.filter(activity => !activity.expectedAnalysisDate);

                const activitiesTakenAssigned = selectedActivities.filter(
                    activity =>
                        activity.expectedAnalysisDate &&
                        new Date(activity.expectedAnalysisDate).toISOString().split('T')[0] === date
                );

                const deltachange = parseInt(value, 10) - activityDistributed.assignedActivitiesIds?.length;


                if (isNaN(deltachange) || deltachange === 0 || deltachange > activitiesTakenNotAssigned.length) {

                    return;
                }

                const isIncreasingOrDecreasing = deltachange > 0 ? 'increasing' : 'decreasing';

                const newTakenActivities = [...activitiesTaken];

                if (isIncreasingOrDecreasing === 'increasing') {
                    const activitiesToAdd = activitiesTakenNotAssigned.slice(0, Math.abs(deltachange));
                    activitiesToAdd.forEach(activity => {
                        const indexOfActivity = newTakenActivities.findIndex(taken => taken.activityId === activity.activityId);
                        newTakenActivities[indexOfActivity] = {
                            ...newTakenActivities[indexOfActivity],
                            expectedAnalysisDate: date
                        }
                    });
                } else {
                    const activitiesToRemove = activitiesTakenAssigned.slice(0, Math.abs(deltachange));
                    activitiesToRemove.forEach(activityId => {
                        const indexOfActivity = newTakenActivities.findIndex(taken => taken.activityId === activityId.activityId);
                        newTakenActivities[indexOfActivity] = {
                            ...newTakenActivities[indexOfActivity],
                            expectedAnalysisDate: undefined
                        }
                    });
                }

                setActivitiesTaken(newTakenActivities);
            }

            if (field === 'comment') {
                const newActivitiesDistributed = [...activitiesDistributedByDay];
                newActivitiesDistributed[activityIndex] = {
                    ...newActivitiesDistributed[activityIndex],
                    comment: value
                };
                setActivitiesDistributedByDay(newActivitiesDistributed);
            }
        }
    }

    const handleOnAutoDivideActivities = () => {
        if (activitiesTaken.length === 0) {
            Swal.fire({
                title: "Debe seleccionar al menos una actividad",
                icon: "warning",
            });
            return;
        }

        // const activitiesSelected = activitiesTaken.filter(activity => selectedRows.includes(activity.activityId));
        const activitiesSelected = activitiesTaken

        const totalActivities = activitiesSelected.length;

        const datesBetween = activitiesDistributedByDay.length;

        let activitiesPerDay = Math.floor(totalActivities / datesBetween);

        if (activitiesPerDay === 0) {
            activitiesPerDay = 1;
        }

        let activitiesTakenNotAssigned = activitiesSelected.filter(activity => !activity.expectedAnalysisDate);

        const newTakenActivities = [...activitiesSelected];

        const lastDate = activitiesDistributedByDay[activitiesDistributedByDay.length - 1].date;

        for (const date of activitiesDistributedByDay) {
            const assignedActivitiesIds = date.assignedActivitiesIds || [];

            const numberOfActivitiesToAdd = activitiesPerDay - assignedActivitiesIds?.length;

            let activitiesToAdd = activitiesTakenNotAssigned.slice(0, Math.abs(numberOfActivitiesToAdd));

            if (date.date === lastDate) {
                activitiesToAdd = activitiesTakenNotAssigned;
            }

            activitiesTakenNotAssigned = activitiesTakenNotAssigned.filter(
                activity => !activitiesToAdd.some(a => a.activityId === activity.activityId)
            );


            activitiesToAdd.forEach(activity => {
                const indexOfActivity = newTakenActivities.findIndex(taken => taken.activityId === activity.activityId);

                newTakenActivities[indexOfActivity] = {
                    ...newTakenActivities[indexOfActivity],
                    expectedAnalysisDate: date.date
                }
            });
        }

        setActivitiesTaken(newTakenActivities);
    }

    return (

        < Box className="modal_analyst_body" >
            <Grid className="dates_section">
                <IconButton onClick={goBack}>
                    <ArrowBackIcon />
                </IconButton>
                {datesToAssigned?.startDate ? (
                    <Typography>
                        Actividades sin analisis desde el
                        <span className="date_text"> {datesToAssigned?.startDate?.format("DD/MM/YYYY") || ""} </span>
                        al
                        <span className="date_text"> {datesToAssigned?.endDate?.format("DD/MM/YYYY") || ""} </span>
                    </Typography>
                ) : (
                    <Typography>Actividades sin analisis hasta el <span className="date_text">{datesToAssigned?.endDate?.format("DD/MM/YYYY") || ""}</span></Typography>
                )}

            </Grid>

            <Grid className="section_activities">
                <Grid className="activity_section">
                    <Grid className="title">Actividades Totales Asignadas : </Grid>
                    <Grid className="value">{summaryActivities.assignedActivities}/{summaryActivities.totalActivities}</Grid>
                </Grid>
                <Grid className="activity_section">
                    <Grid className="title">Actividades Echometer Asignadas : </Grid>
                    <Grid className="value"> {summaryActivities.echometerAssignedActivities}/{summaryActivities.echometerTotalActivities}</Grid>
                </Grid>
                <Grid className="activity_section">
                    <Grid className="title">Actividades Leutert Asignadas : </Grid>
                    <Grid className="value"> {summaryActivities.leutertAssignedActivities}/{summaryActivities.leutertTotalActivities}</Grid>
                </Grid>
            </Grid>
            {!activeUser.fullName && (
                <Grid>
                    <Tabs
                        value={activeTabDateEngineers}
                        onChange={(_, newValue: any) => setActiveTabDateEngineers(newValue)}
                        className="tabs_Section"
                        variant='fullWidth'
                    >
                        <Tab
                            label="Por fecha"
                        />
                        <Tab
                            label="Por Analista"
                        />
                    </Tabs>
                </Grid>)}

            <Grid className="table_header_section">
                {activeUser.fullName && (
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handleCloseEngineerDetail()}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                )}
                {activeUser.fullName && (
                    <Typography className='text'>
                        {activeUser.fullName && `Ingeniero seleccionado : ${activeUser.fullName}`}
                    </Typography>)}
            </Grid>

            {showEngineerDetail && (
                <Grid>
                    <Grid>
                        <Tabs
                            value={activeTab}
                            onChange={(_, newValue: any) => setActiveTab(newValue)}
                            className="tabs_Section"
                            variant='fullWidth'
                        >
                            <Tab
                                label="Asignar"
                                disabled={!showAssignedTasks}
                            />
                            <Tab
                                label="Lista de pozos"
                            />
                            <Tab
                                label="Distribución de Actividades"
                            />
                        </Tabs>
                    </Grid>
                    <Grid>
                        {/* assigned actividades */}
                        {activeTab === 0 && (
                            <Grid sx={{ height: '42vh' }}>
                                <Grid className="assigned_controll_section">
                                    <Grid className="auto_complete_section">
                                        <Typography variant="body1" color="initial" sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', mb: 2 }}>Metodo</Typography>
                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={summaryActivities.methods}
                                            value={filters.method}
                                            onChange={(_: any, newValue: any) => handleChangeSelect('method', newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid className="auto_complete_section">
                                        <Typography variant="body1" color="initial" sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', mb: 2 }}>Tipo de Actividad</Typography>
                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={summaryActivities.typeOfActivities}
                                            value={filters.typeOfActivities}
                                            onChange={(_: any, newValue: any) => handleChangeSelect('typeOfActivities', newValue)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="standard"
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid className="assigned_controll_section">
                                    <Grid className="select_sections">
                                        <Typography variant="body1" color="initial" sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center' }}>Sin Aporte : </Typography>
                                        <Grid className="input_section" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <TextField
                                                type="number"
                                                size="small"
                                                variant="standard"
                                                value={filters.withoutProductionTaken.toString().padStart(2, '0')}
                                                sx={{
                                                    width: '90px',
                                                    '& input': {
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                onChange={(event) => handleChangeSelect('withoutProductionTaken', event.target.value)}
                                            />
                                            <Typography>
                                                / {filteredActivitiesWithoutProduction.length.toString().padStart(2, '0')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid className="select_sections">
                                        <Typography variant="body1" color="initial" sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', }}>Aportando : </Typography>
                                        <Grid className="input_section" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <TextField
                                                type="number"
                                                size="small"
                                                variant="standard"
                                                value={filters.withProductionTaken.toString().padStart(2, '0')}
                                                sx={{
                                                    width: '90px',
                                                    '& input': {
                                                        textAlign: 'center',
                                                    },
                                                }}
                                                onChange={(event) => handleChangeSelect('withProductionTaken', event.target.value)}
                                            />
                                            <Typography>
                                                / {filteredActivitiesWithProduction.length.toString().padStart(2, '0')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                        {/* well locations */}
                        {activeTab === 1 && (
                            <Grid>
                                <DataGrid
                                    rows={activitiesTaken}
                                    columns={columnsTakenActivities}
                                    pageSizeOptions={[10, 20, 50, 100]}
                                    checkboxSelection={true}
                                    rowSelectionModel={selectedRows}
                                    onRowSelectionModelChange={(e) => {
                                        onSelectRows(e as string[]);
                                    }}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: {
                                                activityId: false,
                                                userId: false,
                                            }
                                        },
                                    }}
                                    sx={{
                                        ...tableStyles,
                                        maxHeight: '45vh',
                                    }}
                                    getRowId={(row) => row.activityId}
                                />
                            </Grid>
                        )}
                        {/* activities distribution */}
                        {activeTab === 2 && (
                            <Grid>
                                <Grid className="distributted_buttons">
                                    <Grid>
                                        <Typography>
                                            Actividades seleccionadas: {activitiesAssignedWithDate} / {selectedRows.length}
                                        </Typography>
                                    </Grid>
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => handleOnAutoDivideActivities()}
                                    >
                                        <DateRangeIcon fontSize="medium" />
                                    </IconButton>
                                </Grid>
                                <Grid className='distributted_table'>
                                    <Grid className='header'>
                                        <Grid className='header_text'>Dia</Grid>
                                        <Grid className='header_text'>Plan</Grid>
                                        <Grid className='header_text'>Comentario</Grid>
                                    </Grid>
                                    <Grid className="row_section_assigned_activities">
                                        {activitiesDistributedByDay.map((activity, index) => (
                                            <Grid key={index} className="row_assigned_activities">
                                                <Grid className="row_text">{activity.date}</Grid>
                                                <Grid className="row_text" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <input
                                                        type="number"
                                                        value={activity.assignedActivitiesIds?.length || 0}
                                                        style={{ width: '50px', textAlign: 'center' }}
                                                        onChange={(e) => { handleOnChangeAssignedActivities(e, activity.date, 'plan') }} />
                                                </Grid>
                                                <Grid className="row_text">
                                                    <input
                                                        type="text"
                                                        value={activity.comment || ''}
                                                        onChange={(e) => { handleOnChangeAssignedActivities(e, activity.date, 'comment') }}
                                                        style={{ width: '100%' }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <Grid sx={{ display: 'flex', justifyContent: 'space-between', padding: '5px', gap: '10px' }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: CustomColors.secondary,
                            }}
                            onClick={() => handleCloseEngineerDetail()}
                        >
                            Cerrar
                        </Button>

                        {activeTab === 0 && (
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: CustomColors.blue1,
                                }}
                                onClick={() => handleTakeActivities(

                                )}
                            >
                                Tomar Actividades
                            </Button>
                        )}
                        {activeTab === 1 && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleDistributeActivities()}
                            >
                                Distribuir Actividades
                            </Button>
                        )}
                        {activeTab === 2 && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleAssignedActivities()}
                            >
                                Guardar
                            </Button>
                        )}
                    </Grid>

                </Grid>
            )}
            {!showEngineerDetail && activeTabDateEngineers === 1 && (
                <Grid size={12}>
                    <DataGrid
                        rows={analyzerUsers}
                        columns={columns}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    userId: false,
                                }
                            }
                        }}
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#03365E",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                            maxHeight: '42vh',
                        }}
                        getRowId={(row) => row.userId}
                    />
                </Grid>
            )}
            {!showEngineerDetail && activeTabDateEngineers === 0 && (
                <Grid size={12} className="table_section" sx={{ maxHeight: '42vh', overflow: 'auto' }}>
                    <DataGrid
                        rows={pendingAnalystByDate}
                        columns={columnsFordate}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    userId: false,
                                },
                            },
                            sorting: {
                                sortModel: [
                                    { field: 'date', sort: 'desc' }
                                ]
                            }
                        }} 
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#03365E",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                            maxHeight: '42vh',
                        }}
                        getRowId={(row) => row.date}
                    />
                </Grid>
            )}


        </Box>

    )
}